var map = {
	"./common/Actions": 98896,
	"./complementary/Actions": 52513,
	"./course/Actions": 14692,
	"./customer/Actions": 63910,
	"./dashboard/Actions": 31958,
	"./discount/Actions": 97086,
	"./download/Actions": 75848,
	"./employee/Actions": 39753,
	"./login/Actions": 30554,
	"./menu/Actions": 12459,
	"./modifier/Actions": 3977,
	"./offer/Actions": 35944,
	"./product/Actions": 76994,
	"./report/Actions": 82411,
	"./reward/Actions": 71288,
	"./service/Actions": 87961,
	"./setting/Actions": 44946,
	"./stock/Actions": 84199,
	"./supplier/Actions": 66877,
	"./table/Actions": 3741,
	"./transaction/Actions": 91998,
	"./user/Actions": 71350,
	"./warranty/Actions": 20152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47117;